import request from './request';

export interface ProviderModel {
  id: string;
  providerConfigId: string;
  modelName: string;
  modelType: string;
  displayName: string;
  isEnabled: boolean;
  isDefault: boolean;
  priority: number;
  extraConfig: Record<string, unknown> | null;
  createdAt: number;
  updatedAt: number;
}

export interface ProviderConfig {
  id: string;
  providerName: string;
  providerCode: string;
  apiBaseUrl: string;
  isEnabled: boolean;
  isDefault: boolean;
  timeoutMs: number | null;
  dailyLimit: number | null;
  priority: number;
  extraConfig: Record<string, unknown>;
  hasCredential: boolean;
  apiKeyMasked: string;
  apiSecretMasked: string;
  models: ProviderModel[];
  createdAt: string;
  updatedAt: string;
}

export function getProviders(): Promise<ProviderConfig[]> {
  return request.get('/api/admin/v1/providers');
}

export function getProvider(code: string): Promise<ProviderConfig> {
  return request.get(`/api/admin/v1/providers/${code}`);
}

export function createProvider(data: {
  providerName: string;
  providerCode: string;
  apiBaseUrl?: string;
  isEnabled?: boolean;
  isDefault?: boolean;
  timeoutMs?: number;
  dailyLimit?: number;
  priority?: number;
  extraConfig?: Record<string, unknown>;
  apiKey?: string;
  apiSecret?: string;
}): Promise<ProviderConfig> {
  return request.post('/api/admin/v1/providers', data);
}

export function updateProvider(
  code: string,
  data: {
    providerName?: string;
    apiBaseUrl?: string;
    isEnabled?: boolean;
    isDefault?: boolean;
    timeoutMs?: number;
    extraConfig?: Record<string, unknown>;
    apiKey?: string;
    apiSecret?: string;
  }
): Promise<void> {
  return request.put(`/api/admin/v1/providers/${code}`, data);
}

export function deleteProvider(code: string): Promise<void> {
  return request.delete(`/api/admin/v1/providers/${code}`);
}

// Model 相关 API

export function listProviderModels(code: string): Promise<ProviderModel[]> {
  return request.get(`/api/admin/v1/providers/${code}/models`);
}

export function createProviderModel(
  code: string,
  data: {
    modelName: string;
    modelType: string;
    displayName?: string;
    isEnabled?: boolean;
    isDefault?: boolean;
    priority?: number;
    extraConfig?: Record<string, unknown>;
  }
): Promise<ProviderModel> {
  return request.post(`/api/admin/v1/providers/${code}/models`, data);
}

export function updateProviderModel(
  modelId: string,
  data: {
    modelName?: string;
    modelType?: string;
    displayName?: string;
    isEnabled?: boolean;
    isDefault?: boolean;
    priority?: number;
    extraConfig?: Record<string, unknown>;
  }
): Promise<ProviderModel> {
  return request.put(`/api/admin/v1/providers/models/${modelId}`, data);
}

export function deleteProviderModel(modelId: string): Promise<void> {
  return request.delete(`/api/admin/v1/providers/models/${modelId}`);
}

export function setProviderModelDefault(modelId: string): Promise<void> {
  return request.post(`/api/admin/v1/providers/models/${modelId}/default`);
}
